export default {
  admin: 'Διαχειριστής',
  password: {
    enterNewPassword: 'Εισάγετε νέο κωδικό',
    reenterNewPassword: 'Εισάγετε ξανά τον νέο κωδικό',
    updatePassword: 'Ενημέρωση κωδικού',
    setPassword: 'Ορισμός κωδικού',
    min8CharacterMessage: 'Ο κωδικός πρέπει να έχει τουλάχιστον 8 χαρακτήρες',
    passwordSentMessage: 'Ο κωδικός έχει σταλεί στο {userName} μέσω email.',
    generateNewPassword: 'Δημιουργία νέου κωδικού',
    assignPasswordMessage:
      'Αναθέστε έναν κωδικό στον χρήστη. Ο χρήστης θα χρειαστεί να αλλάξει αυτόν τον κωδικό κατά την επόμενη σύνδεση.',
    generateSecurePassword: 'Δημιουργία ασφαλούς κωδικού',
    newPassword: 'Νέος κωδικός',
    confirmNewPassword: 'Επιβεβαίωση νέου κωδικού',
    passwordHistory: 'Ιστορικό κωδικών',
    passwordUpdatedLog: 'Ο κωδικός ενημερώθηκε από {userName} στις {date}.',
    forgotPasswordLog: 'Το αίτημα για ξεχασμένο κωδικό στάλθηκε από {userName} στις {date}.',
  },
};
